import React from "react";
import { NavTech, SignForm, Footer } from "../components";

const SignUp = () => {
  return (
    <>
      <NavTech />
      <SignForm />
      <Footer />
    </>
  );
};

export default SignUp;
